import React, { useState, useEffect } from "react";
import { Page, Image, Text, Document, View, Note, BlobProvider } from "@react-pdf/renderer";
import { styles } from "../actas_interventoria/StylesActasInterventorias";
import { currencyFormat } from '../../js/Functions';
// IMGS
import logoAmericanLighting from "../../images/American Lighting Logo.png";
import firmaMelissaEscorcia from "../../images/Firma Melissa Escorcia.png";
import firmaPaolaPalmieri from "../../images/Firma-Paola-Palmieri.jpg";





const PDFActasInterventorias = ({ data }) => {

  const [colombianDate, setColombianDate] = useState('')
  const [monthActa, setMonthActa] = useState('')
  const [monthLiquidacionActa, setMonthLiquidacionActa] = useState('')
  let [totalFactRecaudo, setTotalFactRecaudo] = useState(0)

  const getMonthActa = (date) => {
    let mesActa = ''
    switch (date.slice(-2)) {
      case '01': mesActa = "Enero"; break;
      case '02': mesActa = "Febrero"; break;
      case '03': mesActa = "Marzo"; break;
      case '04': mesActa = "Abril"; break;
      case '05': mesActa = "Mayo"; break;
      case '06': mesActa = "Junio"; break;
      case '07': mesActa = "Julio"; break;
      case '08': mesActa = "Agosto"; break;
      case '09': mesActa = "Septiembre"; break;
      case '10': mesActa = "Octubre"; break;
      case '11': mesActa = "Noviembre"; break;
      case '12': mesActa = "Diciembre"; break;
      default: break;
    }
    return mesActa;
    //console.log(date.slice(-2))
  }

  const getMonthLiquidacionActa = (date) => {
    let mesLiquidacionActa = ''
    switch (date.slice(-2)) {
      case '01': mesLiquidacionActa = "Enero"; break;
      case '02': mesLiquidacionActa = "Febrero"; break;
      case '03': mesLiquidacionActa = "Marzo"; break;
      case '04': mesLiquidacionActa = "Abril"; break;
      case '05': mesLiquidacionActa = "Mayo"; break;
      case '06': mesLiquidacionActa = "Junio"; break;
      case '07': mesLiquidacionActa = "Julio"; break;
      case '08': mesLiquidacionActa = "Agosto"; break;
      case '09': mesLiquidacionActa = "Septiembre"; break;
      case '10': mesLiquidacionActa = "Octubre"; break;
      case '11': mesLiquidacionActa = "Noviembre"; break;
      case '12': mesLiquidacionActa = "Diciembre"; break;
      default: break;
    }
    return mesLiquidacionActa;
  }

  const getTotalFactRecaudo = () => {
    let reca = 0;
    if (data[0].resultAportes) {
      data[0].resultAportes.map((aporte) => (
        reca += aporte.VALOR_RECAUDO
      ))
    }
    if (data[0].resultMunicipio) {
      data[0].resultMunicipio.map((municipio) => (
        reca += municipio.VALOR_RECAUDO
      ))
    }
    if (data[0].resultComer) {
      data[0].resultComer.map((comer) => (
        reca += comer.VALOR_RECAUDO
      ))
    }
    return reca;
  }

  const setInfo = () => {


    if (data[0]) {
      const dateStr = data[0].resultActa.FECHA_ACTA;
      const date = new Date(dateStr);

      const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC',
        locale: 'es-CO'
      };

      const formattedDate = date.toLocaleDateString('es-CO', options);
      setColombianDate(formattedDate)
      let monthActa = getMonthActa(data[0].resultActa.PERIODO_ACTA)
      setMonthActa(monthActa)
      let monthLiquidacionActa = getMonthLiquidacionActa(data[0].resultActa.PERIODO_LIQUIDACION)
      setMonthLiquidacionActa(monthLiquidacionActa)
      setTotalFactRecaudo(getTotalFactRecaudo())
    }


  }
  useEffect(() => {
    setInfo()
  })
  //console.log('data in pdf: ', data);


  return (
    data[0] ?
      (
        <Document>
          <Page style={styles.body} size="A4" wrap>
            <View style={styles.view}>
              {/* FUNTION THAT RETURNS THE HEADER */}
              <View style={[{ width: "505px" }]}>
                <Image
                  style={[{ maxWidth: "15%", marginBottom: "15px" }]}
                  src={logoAmericanLighting}
                />
                <Text style={[{ marginBottom: "25px", textTransform: 'capitalize' }]}>
                  {data[0].resultActa.MUNICIPIO.toLowerCase()}, {colombianDate}
                </Text>
                <Text>Señores:</Text>
                <Text style={[styles.text_bold]}>MUNICIPIO DE {data[0].resultActa.MUNICIPIO}</Text>
                <Text>
                  Att: SUPERVISOR CONTRATO DE CONCESIÓN ALUMBRADO PÚBLICO:
                </Text>
                <Text style={[{ textTransform: 'capitalize' }]} >{data[0].resultActa.DEPARTAMENTO.toLowerCase()} - {data[0].resultActa.MUNICIPIO.toLowerCase()}</Text>
                <Text style={[styles.text_bold]}>ASUNTO: <Text style={[styles.notBold]}>ENTREGA DE INFORME MES</Text> <Text style={[styles.text_bold]}>{monthActa.toUpperCase()} {data[0].resultActa.PERIODO_ACTA.slice(0, -2)}</Text> </Text>
                <Text style={[{ marginTop: "20px", marginBottom: "10px" }]}>
                  Cordial saludo,
                </Text>
                <Text style={[{ marginBottom: "15px" }]}>
                  En nuestra calidad de Concesionario nos permitimos remitir la
                  información correspondiente a la gestión adelantada en el periodo
                  de: <Text style={[styles.text_bold]}>{monthActa} {data[0].resultActa.PERIODO_ACTA.slice(0, -2)}</Text>
                </Text>
              </View>
              {/* Tables */}
              <View style={[styles.row, { marginBottom: 18 }]}>
                <View
                  style={[
                    styles.table_row_left,
                    { justifyContent: "center", padding: "1px" },
                  ]}
                >
                  <Text style={[styles.text_bold]}>No.:</Text>
                </View>
                <View
                  style={[
                    styles.table_row_right,
                    { justifyContent: "center", padding: "1px" },
                  ]}
                >
                  <Text style={[styles.text_bold]}>Documento</Text>
                </View>

                <View style={[styles.table_row_left]}>
                  <Text style={[styles.center_text, {}]}>1</Text>
                </View>
                <View style={[styles.table_row_right, {}]}>
                  <Text>Informes Operativos</Text>
                </View>

                <View style={[styles.table_row_left, {}]}>
                  <Text style={[styles.center_text, {}]}>1.1</Text>
                </View>
                <View style={[styles.table_row_right, {}]}>
                  <Text>
                    Listado de reportes de daños de luminarias de Alumbrado Público
                    presentado por los usuarios.
                  </Text>
                </View>

                <View style={[styles.table_row_left, {}]}>
                  <Text style={[{ marginTop: "30%" }]}>1.2</Text>
                </View>
                <View style={[styles.table_row_right, {}]}>
                  <Text>
                    Listado de luminarias a las cuales se les realizó mantenimiento
                    indicando: fecha de mantenimiento, código de luminaria a la cual
                    se le realizo el mantenimiento, elementos cambiados a la
                    luminaria y dirección y/o lugar de ubicación de la luminaria.
                  </Text>
                </View>

                <View style={[styles.table_row_left, {}]}>
                  <Text style={[styles.center_text, {}]}>1.3</Text>
                </View>
                <View style={[styles.table_row_right, {}]}>
                  <Text>
                    {" "}
                    Expansiones en alumbrado público realizadas en el periodo.
                  </Text>
                </View>

                <View style={[styles.table_row_left, {}]}>
                  <Text style={[{ marginTop: "60%" }]}>2</Text>
                </View>
                {/* List */}
                <View style={[styles.table_row_right, { flexDirection: "column" }]}>
                  <Text style={[{ marginBottom: "10px" }]}>
                    Informe de gestión donde se evidencian el resultado de los
                    indicadores contractuales del mes y que incluye lo siguiente:
                  </Text>

                  <View style={[{ flexDirection: "row", paddingTop: 1 }]}>
                    <Text style={{ marginHorizontal: "10px" }}>•</Text>
                    <Text>
                      Efectividad de ejecución de mantenimientos preventivos.
                    </Text>
                  </View>
                  <View style={[{ flexDirection: "row", paddingTop: 1 }]}>
                    <Text style={{ marginHorizontal: "10px" }}>•</Text>
                    <Text>Efectividad de ejecución para cerrar solicitudes.</Text>
                  </View>
                  <View style={[{ flexDirection: "row", paddingTop: 1 }]}>
                    <Text style={{ marginHorizontal: "10px" }}>•</Text>
                    <Text>Plazo medio de resolución.</Text>
                  </View>
                </View>

                <View style={[styles.table_row_left, {}]}>
                  <Text style={[styles.center_text, {}]}>3</Text>
                </View>
                <View style={[styles.table_row_right, {}]}>
                  <Text>
                    Conciliación de facturación y recaudo del impuesto de alumbrado
                    público mensual.
                  </Text>
                </View>

                <View style={[styles.table_row_left, {}]}>
                  <Text style={[styles.center_text, {}]}>4</Text>
                </View>
                <View style={[styles.table_row_right, {}]}>
                  <Text>Extracto Fiduciarios y Bancarios.</Text>
                </View>

                <View style={[styles.table_row_left, {}]}>
                  <Text style={[styles.center_text, {}]}>5</Text>
                </View>
                <View style={[styles.table_row_right, {}]}>
                  <Text>
                    Copia de factura por operación y mantenimiento y retorno a la
                    inversión.
                  </Text>
                </View>

                <View style={[styles.table_row_left, {}]}>
                  <Text style={[styles.center_text, {}]}>6</Text>
                </View>
                <View style={[styles.table_row_right, {}]}>
                  <Text>Ordenes de traslado Encargo Fiduciario.</Text>
                </View>

                <View style={[styles.table_row_left, {}]}>
                  <Text style={[{ marginTop: "20%" }]}>7</Text>
                </View>
                <View style={[styles.table_row_right, {}]}>
                  <Text>
                    Certificado de pago oportuno a los sistemas de seguridad social
                    en salud, pensión, riesgos profesionales, correspondientes a los
                    trabajadores y/o empleados durante el último mes.
                  </Text>
                </View>

                <View
                  style={[
                    styles.table_row_left,
                    { borderBottom: "1px solid black" },
                  ]}
                >
                  <Text style={[styles.center_text, {}]}>8</Text>
                </View>
                <View
                  style={[
                    styles.table_row_right,
                    { borderBottom: "1px solid black" },
                  ]}
                >
                  <Text>
                    Pólizas de garantía del contrato de concesión de alumbrado
                    público.
                  </Text>
                </View>
              </View>
              {/* Fin tabla */}
              <View style={[{ width: "505px" }]}>
                <Text>
                  Así mismo, durante el periodo se realizaron las siguientes
                  actividades de apoyo a la gestión: {data[0].resultActa.OBSERVACIONES.toUpperCase()}
                </Text>
                <Text style={[{ marginTop: "15px", marginBottom: "30px" }]}>
                  De acuerdo con lo anterior se deja constancia del cumplimiento de
                  las obligaciones contractuales,quedando atentos a cualquier
                  inquietud o comentario sobre la información entregada.
                </Text>
                <Text>Atentamente,</Text>
                <Image
                  style={{ maxWidth: "25%", marginTop: "30px" }}
                  src={firmaPaolaPalmieri}
                />
                <Text style={[styles.text_bold]}>PAOLA PALMIERI M</Text>
                <Text>JEFE DE OPERACIONES COMERCIALES</Text>
                <Text>UNIDAD DE ALUMBRADO PÚBLICO</Text>
              </View>
            </View>
            {/* FINALIZA LA PRIMERA PARTE */}

            {/* Break page */}
            <View break style={{ width: 505, textAlign: 'center', }}>

              <Text style={[styles.text_bold, { fontSize: 13, marginBottom: 15 }]} >
                6. Conciliación de Facturación y Recaudo del Impuesto de Alumbrado
                Público Mensual. Periodo: {monthLiquidacionActa} {data[0].resultActa.PERIODO_LIQUIDACION.slice(0, -2)}
              </Text>

              {/* New tables */}
              <View style={[styles.table_header]}>
                <Text >Descripción:</Text>
              </View>
              <View style={[styles.table_header, { borderTop: 0 }]}>
                <Text >Liquidación Operador de Red.</Text>
              </View>
              <View style={[styles.row, styles.text_bold, { border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>
                <View style={{ width: 80, borderRight: '1px solid black', padding: 1 }}>
                  <Text >FACTURADO</Text>
                </View>
                <View style={{ width: 80, borderRight: '1px solid black', padding: 1 }}>
                  <Text >RECAUDO</Text>
                </View>
                <View>
                  <Text style={{ width: 120, borderRight: '1px solid black', padding: 1 }}>COSTO DE ENERGIA</Text>
                </View>
                <View>
                  <Text style={{ width: 120, borderRight: '1px solid black', padding: 1 }}>OTRAS DEDUCCIONES</Text>
                </View>
                <View>
                  <Text style={{ width: 100, }}>TRASLADO NETO</Text>
                </View>

              </View>
              {/* Valores */}
              <View style={[styles.row, { border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>

                <View style={{ width: 80, borderRight: '1px solid black', padding: 1 }}>
                  {/* FACTURADO */}
                  <Text  >$ {currencyFormat(data[0].resultActa.VALOR_FACTURADO)}</Text>
                </View>
                <View style={{ width: 80, borderRight: '1px solid black', padding: 1 }}>
                  {/* RECAUDO */}
                  <Text >$ {currencyFormat(data[0].resultActa.VALOR_RECAUDO)}</Text>
                </View>
                <View>
                  {/* COSTO DE ENERGIA */}
                  <Text style={{ width: 120, borderRight: '1px solid black', padding: 1 }}>$ {currencyFormat(data[0].resultActa.COSTO_ENERGIA)}</Text>
                </View>
                <View>
                  {/* OTRAS DEDUCCIONES */}
                  <Text style={{ width: 120, borderRight: '1px solid black', padding: 1 }}>$ {currencyFormat(data[0].resultActa.OTRAS_DEDUCCIONES)}</Text>
                </View>
                <View>
                  {/* TRASLADO NETO */}
                  <Text style={{ width: 100, }}>$ {currencyFormat(data[0].resultActa.TRASLADO_NETO)}</Text>
                </View>

              </View>

              {/* SECOND TABLE */}
              <View style={[styles.table_header, { marginTop: 15 }]}>
                <Text >Descripción:</Text>
              </View>
              <View style={[styles.table_header, { borderTop: 0 }]}>
                <Text >Facturación Otros Agentes de Recaudo.</Text>
              </View>

              <View style={[styles.row, styles.text_bold, { border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>
                <View style={{ width: 300, borderRight: '1px solid black', }}>
                  <Text style={{ marginTop: 5 }} >FUENTE DEL RECAUDO</Text>
                </View>
                <View style={{ width: 100, borderRight: '1px solid black', }}>
                  <Text >VALOR</Text>
                  <Text >TRASLADO </Text>
                </View>
                <View>
                  <Text style={{ width: 100, }}>AGENTE</Text>
                  <Text style={{ width: 100, }}>RECAUDADOR</Text>
                </View>
              </View>

              {/* VALORES */}


              {
                data[0].resultAportes ?
                  (
                    data[0].resultAportes.map((aporte) => (
                      <View style={[styles.row, { height: 15, border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>
                        <View style={{ height: 15, width: 300, borderRight: '1px solid black', justifyContent: 'center', alignItems: 'center', }} >
                          <Text style={{ fontSize: 7 }}>MUNICIPIO</Text>
                        </View>
                        <View style={{height: 15, width: 100, borderRight: '1px solid black', justifyContent: 'center', alignItems: 'center',}}>
                          <Text style={{fontSize: 7 }}> $ {currencyFormat(aporte.VALOR_RECAUDO)}</Text>
                        </View>
                        <View style={{height: 15, width: 100, justifyContent: 'center', alignItems: 'center',}}>
                          <Text style={{ width: 100, fontSize: 7 }}>MUNICIPIO</Text>
                        </View>
                      </View>
                    ))
                  )
                  :
                  ""
              }
              {
                data[0].resultMunicipio ?
                  (
                    data[0].resultMunicipio.map((municipio) => (
                      <View style={[styles.row, { height: 15, border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>                     
                        <View style={{ height: 15, width: 300, borderRight: '1px solid black', justifyContent: 'center', alignItems: 'center', }}>
                          <Text style={{ fontSize: 7 }}>{municipio.NOMBRE}</Text>
                        </View>
                        <View style={{height: 15, width: 100, borderRight: '1px solid black', justifyContent: 'center', alignItems: 'center',}}>
                          <Text style={{ fontSize: 7 }}>$ {currencyFormat(municipio.VALOR_RECAUDO)}</Text>
                        </View>
                        <View style={{height: 15, width: 100, justifyContent: 'center', alignItems: 'center',}}>
                          <Text style={{fontSize: 7,  }}>MUNICIPIO</Text>
                        </View>
                      </View>
                    ))
                  )
                  :
                  ""
              }
              {
                data[0].resultComer ?
                  (
                    data[0].resultComer.map((comer) => (
                      <View style={[styles.row, { height: 15, border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>
                        <View style={{ height: 15, width: 300, borderRight: '1px solid black', justifyContent: 'center', alignItems: 'center', }}>
                          <Text style={{ fontSize: 6.8 }}>{comer.NOMBRE}</Text>
                        </View>
                        <View style={{height: 15, width: 100, borderRight: '1px solid black', justifyContent: 'center', alignItems: 'center',}}>
                          <Text style={{ fontSize: 7 }}>$ {currencyFormat(comer.VALOR_RECAUDO)}</Text>
                        </View>
                        <View style={{height: 15, width: 100, justifyContent: 'center', alignItems: 'center',}}>
                          <Text style={{fontSize: 7 }}>COMERCIALIZADORA</Text>
                        </View>
                      </View>
                    ))
                  )
                  :
                  ""
              }


              {/* TOTAL */}
              <View style={[styles.row, { border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>
                <View style={{ width: 300, borderRight: '1px solid black', }}>
                  <Text style={[styles.text_bold, { fontSize: 8 }]}>TOTAL</Text>
                </View>
                <View style={{ width: 100, borderRight: '1px solid black', }}>
                  <Text style={[styles.text_bold, { fontSize: 8 }]}>$ {currencyFormat(totalFactRecaudo)}</Text>
                </View>
                <View>
                  <Text style={{ width: 100, }}></Text>
                </View>
              </View>
            </View>
            {/* THIRD TABLE */}
            <View break style={{ width: 505, textAlign: 'center', }}>


              <Text style={[styles.text_bold, { fontSize: 13, marginBottom: 15, }]} >
                8. Facturación por Operación y Mantenimiento y Retorno de la Inversión
              </Text>
              <View style={[styles.table_header]}>
                <Text >Descripción:</Text>
              </View>
              <View style={[styles.table_header, { borderTop: 0 }]}>
                <Text >Factura Realizada por el Concesionario.</Text>
              </View>
              <View style={[styles.row, styles.text_bold, { border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>
                <View style={{ width: 80, borderRight: '1px solid black', padding: 1 }}>
                  <Text >NO. FACTURA</Text>
                </View>
                <View style={{ width: 120, borderRight: '1px solid black', padding: 1 }}>
                  <Text >FECHA FACTURA</Text>
                </View>
                <View>
                  <Text style={{ width: 80, borderRight: '1px solid black', padding: 1 }}>CONCEPTO</Text>
                </View>
                <View>
                  <Text style={{ width: 80, borderRight: '1px solid black', padding: 1 }}>PERIODO</Text>
                </View>
                <View>
                  <Text style={{ width: 120, }}>VALOR BRUTO + I.V.A.</Text>
                </View>

              </View>
              {/* Valores */}
              {
                data[0].resultConcesion ?
                  (
                    data[0].resultConcesion.map((concesion) => (
                      <View style={[styles.row, { border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>
                        <View style={{ width: 80, borderRight: '1px solid black', padding: 1 }}>
                          {/* NO. FACTURA */}
                          <Text style={{ fontSize: 8 }}>{concesion.NO_FACTURA}</Text>
                        </View>
                        <View style={{ width: 120, borderRight: '1px solid black', padding: 1 }}>
                          {/* FECHA FACTURA */}
                          <Text style={{ fontSize: 8 }}>{concesion.FECHA_FACTURA}</Text>
                        </View>
                        <View>
                          {/* CONCEPTO */}
                          <Text style={{ width: 80, borderRight: '1px solid black', padding: 1, fontSize: 8 }}>{concesion.NOMBRE}</Text>
                        </View>
                        <View>
                          {/* PERIODO */}
                          <Text style={{ width: 80, borderRight: '1px solid black', padding: 1, fontSize: 8 }}>{concesion.PERIODO}</Text>
                        </View>
                        <View>
                          {/* VALOR BRUTO + I.V.A. */}
                          <Text style={{ width: 120, fontSize: 8 }}>$ {currencyFormat(concesion.VALOR_NETO_LOCAL)}</Text>
                        </View>
                      </View>
                    ))
                  )
                  :
                  ""
              }

            </View>

            <Text
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
              fixed
            />
          </Page>
        </Document>
      )
      :
      ""

  );
};

export default PDFActasInterventorias;
